// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__36b7v","list":"PatternAutocomplete_list__RImPz"};